<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Launchpads</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.launchpads.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new launchpad</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Launchpad ID</th>
                <th class="px-6 pt-6 pb-4">Launchpad Name</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="launchpad in launchpads.data" :key="launchpad.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.launchpads.edit', launchpad.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ launchpad.id }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link :href="route('admin.launchpads.edit', launchpad.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ launchpad.name }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="launchpad.status ? 'green' : 'gray'">
                            {{ launchpad.status ? 'Visible' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="launchpads.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No Launchpads found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="launchpads.links" />
</app-layout>
